import React from 'react';
import SegmentedButtonItem from './SegmentedButtonItem';
import './SegmentedButton.css';

// Manual heater position. Controlled by the parent: `position` is the backend enum name from /status,
// `onSelect` is called with the TernaryHeaterPosition ordinal the backend expects. Dimmed when the
// room is not in Manual mode (still tappable — selecting a position switches the backend to Manual).
const POSITIONS = [
  { label: 'PILOTO', value: 1, name: 'Pilot' },
  { label: 'MIN', value: 2, name: 'Minimum' },
  { label: 'MAX', value: 3, name: 'Maximum' },
];

const SegmentedButton = ({ position, dimmed, onSelect }) => (
  <div className="btn-group d-flex" style={{ opacity: dimmed ? 0.45 : 1 }}>
    {POSITIONS.map(({ label, value, name }) => (
      <SegmentedButtonItem
        key={value}
        option={label}
        isSelected={name === position}
        onClick={() => onSelect(value)}
      />
    ))}
  </div>
);

export default SegmentedButton;
